/*=============================================== Input common props ===============================================*/

import { commonProps, iconBoxicon } from "./"
import type { PropsItemType } from "components"

type SeparatorType = "large" | "small"

const returnSeparator = (separator?: SeparatorType) => {
    const a: PropsItemType =
        separator === "small" ? "separator-small" : "separator"
    return a
}

export const validationStatus: PropsItemType = {
    subtitle: "validation",
    type: "string",
    possible: ["passed", "not-passed"],
}

export const validationObject = (separator?: SeparatorType) => {
    const ab: PropsItemType[] = [
        returnSeparator(separator),
        {
            ...validationStatus,
            type: "string or object",
            possible: ["passed", "not-passed", "object"],
        },
        {
            title: "validation object",
            subtitle: "status",
            intro: "This is required if you add validation.",
            type: "string",
            possible: ["passed", "not-passed"],
            required: true,
        },
        {
            subtitle: "iconPassed",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("check-circle"),
        },
        {
            subtitle: "iconNotPassed",
            type: "string",
            default: iconBoxicon("x-circle"),
        },
    ]

    return ab
}

export const accentColor = (title?: string) => {
    const ab: PropsItemType = {
        title,
        subtitle: "accentColor",
        type: "string",
        possible: commonProps.colorsHover,
        default: "primary",
    }

    return ab
}

export const inputVariants = (subtitle = "variant") => {
    const a: PropsItemType = {
        subtitle,
        type: "string",
        possible: ["rounded", "pill"],
        default: "rounded",
    }

    return a
}

export const inputBackgroundColor = (subtitle = "backgroundColor") => {
    const a: PropsItemType = {
        subtitle,
        type: "string",
        possible: ["light", "dark"],
        default: commonProps.backgroundInputDefault,
    }

    return a
}

export const listVariant: PropsItemType[] = [
    {
        subtitle: "listVariant",
        type: "string",
        possible: ["bordered", "shadow"],
        default: "bordered",
    },
    {
        subtitle: "listShadow",
        intro: (
            <>
                This is possible only if the <code>listVariant</code> is set to{" "}
                <code>shadow</code>.
            </>
        ),
        type: "string",
        possible: commonProps.allShadows,
        default: "s",
    },
    {
        subtitle: "listDirection",
        type: "string",
        possible: ["up", "down"],
        default: "down",
    },
]

export const listDirection = (subtitle = "listDirection") => {
    const item: PropsItemType = {
        subtitle,
        type: "string",
        possible: ["up", "down"],
        default: "down",
    }

    return item
}

export const inputLabel = (separator?: SeparatorType) => {
    const content: PropsItemType[] = [
        returnSeparator(separator),
        {
            subtitle: "label",
            type: "string",
        },
        {
            subtitle: "helper",
            type: "string",
        },
        {
            subtitle: "helperBottom",
            type: "string or object",
        },
        {
            title: "helperBottom object",
            subtitle: "text",
            type: "string",
            required: true,
        },
        {
            subtitle: "icon",
            type: "string",
        },
        {
            subtitle: "iconColor",
            type: "string",
            possibleString: commonProps.allColors,
            default: "primary",
        },
    ]

    return content
}

export const inputIcon = (hideIntro = false) => {
    const a: PropsItemType[] = [
        {
            subtitle: "icon",
            intro: !hideIntro ? commonProps.addIconCapital : "",
            type: "string",
        },
        {
            subtitle: "iconSize",
            type: "number",
            default: 24,
        },
    ]

    return a
}

export const inputCounter: PropsItemType[] = [
    {
        subtitle: "maxLength",
        type: "number",
    },
    {
        subtitle: "counter",
        type: "boolean",
    },
]
